import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { api } from '../lib/api';
import { AuthLayout } from '../components/AuthLayout';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.requestPasswordReset({ email });
    } catch {
      // 204 anti-enumeration — não revelamos se o email existe.
    } finally {
      setSubmitting(false);
      setDone(true);
    }
  }

  return (
    <AuthLayout>
      <h1 className="font-display text-ink-100 text-xl font-semibold">Recuperar senha</h1>
      <p className="text-ink-400 mt-1 text-sm">
        Informe seu email e enviaremos um link para redefinir a senha.
      </p>

      {done ? (
        <div className="mt-6">
          <div className="bg-success-500/10 border-success-500/30 text-success-600 rounded-lg border px-3 py-3 text-sm">
            Se houver uma conta com esse email, enviamos um link de redefinição. Verifique sua caixa
            de entrada (e o spam).
          </div>
          <Link
            to="/login"
            className="text-navy-primary hover:text-navy-primary/80 mt-5 inline-block text-sm font-medium"
          >
            ← Voltar para o login
          </Link>
        </div>
      ) : (
        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email" className="text-ink-300 mb-1.5 block text-xs font-semibold">
              Email
            </label>
            <div className="relative">
              <Mail size={14} className="text-ink-500 absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                className="border-ink-800 text-ink-100 placeholder:text-ink-500 focus:border-navy-primary focus:ring-navy-primary/20 w-full rounded-lg border bg-white py-2.5 pl-9 pr-3 text-sm outline-none focus:ring-2"
                disabled={submitting}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="bg-navy-primary hover:bg-navy-primary/90 shadow-soft mt-2 w-full rounded-lg py-3 text-sm font-semibold text-white transition-colors disabled:opacity-50"
          >
            {submitting ? 'Enviando…' : 'Enviar link de redefinição'}
          </button>

          <Link
            to="/login"
            className="text-navy-primary hover:text-navy-primary/80 block pt-1 text-xs font-medium"
          >
            ← Voltar para o login
          </Link>
        </form>
      )}
    </AuthLayout>
  );
}
